<template>
  <div>
    <multiselect class="" v-model="selectedTemplate" :options="templateNames" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
    <button class="mylisting-button dark-button mt-2" @click="addDocument()">Add Document</button>

    <modal name="document-added-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Document added!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-added-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      templates: [],
      templateNames: [],
      selectedTemplate: '',
    }
  },
  created() {
    this.getTemplates()
  },
  methods: {
    getTemplates() {
      let typeSelector = ''
      if (this.user.is_candidate) {
        typeSelector = 'Candidate'
      }
      else if (this.user.is_employer) {
        // typeSelector = 'Client'
        typeSelector = 'Employer'
      }
      axios.get(`/api/documenttemplates/?agency=${this.$store.getters.agencyID}&type=${typeSelector}`)
        .then(res => {
          this.templates = res.data
          this.templateNames = this.templates.map(
            template => `${template.name}`
          );
        })
        .catch(error => {
          console.log(error)
        })
    },
    addDocument() {
      let template = this.templates.filter(template => template.name == this.selectedTemplate)[0]

      axios.post('/api/documents/', {
        title: template.name,
        template: template.id,
        signing_user: this.user.id,
        status: 'Unsigned',
        body: template.body,
        fields_labels: template.fields,
        fields_required: template.fields_required,
        edit_access: template.edit_access,
        organization_signer: template.organization_signer,
        signer_labels: template.signer_labels,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.$modal.show('document-added-modal')
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/DocumentManager.vue